<template>
  <el-col :span="24" :style="{height: height}">
    <div :class="className" :style="{height:chartHeight,width:chartWidth}" />
</el-col>
</template>

<script>
  import echarts from 'echarts'
  require('echarts/theme/macarons') // echarts theme
  import {
    debounce
  } from '../utils/helper.js'
  import lodash from 'lodash'
  export default {
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      width: {
        type: Number,
        default: 24
      },
      height: {
        type: String,
        default: '100%'
      },
       show:{
              type:Boolean,
              default:true
            },
      // 图标配置
      chartConfig: {
        type: Object,
        default: null
      }

    },
    data() {
      return {
        chart: null,
        chartConfigModel: {},
        chartWidth: '100%',
         chartHeight:'100%',
        defaultConfig: {
          title: {
            text: '',
            subtext: '',
            left: 'center'
          },
          tooltip: {
            align:'left'
          },
          legend: {
            data: []
          },
         radar: {
                 // shape: 'circle',
                 name: {
                     textStyle: {
                         color: '#000',
                         borderRadius: 3,
                         padding: [3, 5]
                     }
                 },
                 indicator: []
          },
          series:  [{
							type: 'radar',
							data: [],
							label: {
								show: false
							}
						}]
        }
      }
    },
    watch: {
      // 防止表格预置数据不成功，涉及生命周期问题
      chartConfig: {
        handler(newValue, oldValue) {
          this.chartConfigModel = lodash.cloneDeep(newValue)
         let _config=lodash.cloneDeep(this.defaultConfig)
         lodash.merge(_config,this.chartConfigModel)
         this.chartConfigModel=_config
          this.setOptions(false)
        },
        deep: true
      },
      height: {
        handler(newValue, oldValue) {
          this.__resizeHandler()
        },
        deep: true
      },
      width: {
        handler(newValue, oldValue) {
          this.__resizeHandler()
        },
        deep: true
      },
        show:{
              handler(newValue,oldValue){
                this.__resizeHandler()
              },
              deep:true
            }
    },
    mounted() {
      this.chartConfigModel = lodash.cloneDeep(this.chartConfig)
      let _config=lodash.cloneDeep(this.defaultConfig)
      lodash.merge(_config,this.chartConfigModel)
      this.chartConfigModel=_config
      this.initChart()

      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      window.removeEventListener('resize', this.__resizeHandler)
      this.chart.dispose()
      this.chart = null
    },
    methods: {
      setOptions(notMerge) {
        this.chart.setOption(this.chartConfigModel, notMerge)
        this.chart.resize()
      },
      initChart() {
        this.chart = echarts.init(this.$el, 'macarons')
        this.setOptions(false)
        this.chart.on('finished', function() {
          try {
            var _charts = document.getElementsByTagName('canvas')
            for (var i = 0; i < _charts.length; i++) {
              _charts[i].style.cursor = 'default'
            }
          } catch (e) {

          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/RadarChart.vue